import { render } from "./BootstrapDataList.vue?vue&type=template&id=9516fa84"
import script from "./BootstrapDataList.vue?vue&type=script&lang=js"
export * from "./BootstrapDataList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__